import { SvgIcon } from '@mui/material';

const styles = { width: '232px!important', height: '140px!important' };

export const ErrorIcon = () => {
  return (
    <SvgIcon width="232" height="140" viewBox="0 0 232 140" fill="none" sx={styles}>
      <g clipPath="url(#clip0_8214_37728)">
        <path
          d="M64.8712 108.237C74.2876 100.204 88.349 74.2705 88.349 74.2705L61.9539 58.6989L41.8653 107.412C41.8653 107.412 52.8831 118.453 64.8712 108.237Z"
          fill="#FFAE80"
        />
        <path
          d="M68.0676 104.932L33.1068 50.9691L16.2942 59.9454C16.2942 59.9454 27.4516 84.4208 33.2596 96.0748C48.6833 127.027 68.0676 104.932 68.0676 104.932Z"
          fill="#FFAE80"
        />
        <path
          d="M19.4574 66.6133L16.2943 59.952C5.42259 56.463 -1.32901 54.5306 0.212692 49.927C0.817413 48.1133 4.29289 49.3598 8.47942 49.7885C12.2473 50.1776 19.1119 50.448 19.1119 48.7662C19.1119 46.5172 14.3339 46.8601 14.1811 44.1099C13.995 40.8584 19.9093 42.5468 24.4547 44.2418C29.8373 46.2204 33.0935 50.9691 33.0935 50.9691L36.8016 56.8258L19.4574 66.6133Z"
          fill="#FFAE80"
        />
        <path
          d="M167.129 108.237C157.712 100.204 143.644 74.2705 143.644 74.2705L170.039 58.6989L190.128 107.412C190.128 107.412 179.117 118.453 167.129 108.237Z"
          fill="#FFAE80"
        />
        <path
          d="M163.932 104.932L198.893 50.9691L215.706 59.9454C215.706 59.9454 204.548 84.4142 198.734 96.0748C183.31 127.027 163.932 104.932 163.932 104.932Z"
          fill="#FFAE80"
        />
        <path
          d="M212.543 66.6133L215.706 59.952C226.571 56.4696 233.309 54.5372 231.787 49.9336C231.183 48.1199 227.707 49.3664 223.521 49.7951C219.753 50.1842 212.888 50.4546 212.888 48.7728C212.888 46.5238 217.666 46.8667 217.819 44.1165C217.998 40.865 212.084 42.5534 207.545 44.2484C202.163 46.227 198.873 50.9757 198.873 50.9757L195.165 56.8323L212.543 66.6133Z"
          fill="#FFAE80"
        />
        <path
          d="M159.228 80.7934V140H72.9054L72.7658 80.9451L54.1923 74.752C56.6287 60.1835 64.1972 46.9466 75.5492 37.3994C86.9013 27.8522 101.3 22.6149 116.179 22.6204C131.059 22.626 145.453 27.874 156.798 37.4297C168.143 46.9853 175.701 60.2279 178.127 74.7982L159.228 80.7934Z"
          fill="#EB4755"
        />
        <path
          d="M116.113 0.0989292C113.338 0.105914 110.68 1.2048 108.72 3.15459C106.76 5.10439 105.66 7.74591 105.66 10.4998V26.1045C105.625 27.4928 105.87 28.8741 106.381 30.167C106.892 31.4599 107.658 32.6382 108.635 33.6325C109.612 34.6268 110.78 35.417 112.069 35.9565C113.358 36.496 114.744 36.774 116.143 36.774C117.542 36.774 118.927 36.496 120.217 35.9565C121.506 35.417 122.674 34.6268 123.651 33.6325C124.627 32.6382 125.394 31.4599 125.905 30.167C126.416 28.8741 126.661 27.4928 126.626 26.1045V10.4998C126.626 9.13119 126.354 7.776 125.825 6.51195C125.296 5.2479 124.521 4.09984 123.545 3.1336C122.568 2.16735 121.409 1.40192 120.134 0.881166C118.858 0.360415 117.492 0.0945898 116.113 0.0989292V0.0989292Z"
          fill="#FFAE80"
        />
        <path
          d="M105.627 25.3328C107.722 25.3328 109.421 23.6467 109.421 21.5669C109.421 19.487 107.722 17.8009 105.627 17.8009C103.531 17.8009 101.832 19.487 101.832 21.5669C101.832 23.6467 103.531 25.3328 105.627 25.3328Z"
          fill="#FFAE80"
        />
        <path
          d="M126.593 25.3328C128.688 25.3328 130.387 23.6467 130.387 21.5669C130.387 19.487 128.688 17.8009 126.593 17.8009C124.497 17.8009 122.798 19.487 122.798 21.5669C122.798 23.6467 124.497 25.3328 126.593 25.3328Z"
          fill="#FFAE80"
        />
        <path
          d="M116.113 36.479C117.49 36.479 118.853 36.2098 120.125 35.6867C121.397 35.1636 122.552 34.3969 123.526 33.4303C124.499 32.4638 125.271 31.3165 125.797 30.0538C126.323 28.7912 126.593 27.438 126.593 26.0715H105.66C105.658 28.8266 106.758 31.4698 108.718 33.421C110.677 35.3723 113.337 36.472 116.113 36.479Z"
          fill="#2F313F"
        />
        <path d="M126.593 15.5255H124.473V26.0781H126.593V15.5255Z" fill="#2F313F" />
        <path d="M107.747 15.5255H105.627V26.0781H107.747V15.5255Z" fill="#2F313F" />
        <path
          d="M116.113 33.4649C118.95 33.4649 121.25 31.1824 121.25 28.3667C121.25 25.551 118.95 23.2685 116.113 23.2685C113.276 23.2685 110.976 25.551 110.976 28.3667C110.976 31.1824 113.276 33.4649 116.113 33.4649Z"
          fill="#2F313F"
        />
        <path
          d="M116.113 2.05482e-06C117.515 1.78506e-06 118.903 0.274195 120.199 0.806913C121.494 1.33963 122.671 2.12044 123.662 3.10471C124.653 4.08898 125.439 5.25743 125.975 6.54329C126.511 7.82916 126.786 9.20723 126.785 10.5988H105.434C105.433 9.20667 105.709 7.82806 106.245 6.54177C106.781 5.25548 107.568 4.08673 108.56 3.10238C109.552 2.11802 110.729 1.33735 112.025 0.805019C113.321 0.272688 114.71 -0.000865023 116.113 2.05482e-06V2.05482e-06Z"
          fill="#C91D2B"
        />
        <path
          d="M126.493 9.24011H105.833C104.556 9.24011 103.52 10.2677 103.52 11.5353V13.2303C103.52 14.4979 104.556 15.5255 105.833 15.5255H126.493C127.77 15.5255 128.805 14.4979 128.805 13.2303V11.5353C128.805 10.2677 127.77 9.24011 126.493 9.24011Z"
          fill="#EB4755"
        />
      </g>
      <defs>
        <clipPath id="clip0_8214_37728">
          <rect width="232" height="140" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
